/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Pit1_DInputs */

const en_minifier_pit1_d = /** @type {(inputs: Minifier_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minifying removes redundant characters but leaves the result as plain text that a human can still read. It is not gzip, brotli, or a binary format like MessagePack or CBOR. If you need a genuinely small payload, compress after minifying, and expect compression to do most of the work.`)
};

const ko_minifier_pit1_d = /** @type {(inputs: Minifier_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축은 불필요한 문자를 제거하지만 결과는 사람이 여전히 읽을 수 있는 평문입니다. gzip이나 brotli가 아니고, MessagePack이나 CBOR 같은 이진 형식도 아닙니다. 정말 작은 페이로드가 필요하면 압축한 뒤 다시 압축 알고리즘을 적용하고, 대부분의 일은 그 압축이 한다고 예상하세요.`)
};

const ja_minifier_pit1_d = /** @type {(inputs: Minifier_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮は不要な文字を取り除きますが、結果は人がまだ読める平文です。gzip や brotli ではなく、MessagePack や CBOR のようなバイナリ形式でもありません。本当に小さなペイロードが必要なら、圧縮してから圧縮アルゴリズムをかけ、仕事の大半はそちらがやると考えてください。`)
};

/**
* | output |
* | --- |
* | "Minifying removes redundant characters but leaves the result as plain text that a human can still read. It is not gzip, brotli, or a binary format like Messa..." |
*
* @param {Minifier_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_pit1_d = /** @type {((inputs?: Minifier_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_pit1_d(inputs)
	if (locale === "ko") return ko_minifier_pit1_d(inputs)
	return ja_minifier_pit1_d(inputs)
});